import React from 'react';

export const FaceCoquettishIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M4 25.942C4 28.1739 5.76327 30 7.91837 30H24.0816C26.2367 30 28 28.0725 28 25.8406V6.4297C28 5.1297 26.4099 4.5297 25.5155 5.4297L20.9736 10H11.1617L6.5 5.4297C5.6 4.5297 4 5.1297 4 6.4297V25.942Z"
        fill="#FFB02E"
      />
      <path
        d="M9.00005 10.9265L6.20005 13.5265C5.70005 14.0265 4.80005 13.6265 4.80005 12.9265V7.72648C4.80005 7.12648 5.70005 6.72648 6.20005 7.22648L9.00005 9.82648C9.30005 10.1265 9.30005 10.6265 9.00005 10.9265Z"
        fill="#FF822D"
      />
      <path
        d="M23.05 10.9265L25.85 13.5265C26.35 14.0265 27.25 13.6265 27.25 12.9265V7.72648C27.25 7.12648 26.35 6.72648 25.85 7.22648L23.05 9.82648C22.75 10.1265 22.75 10.6265 23.05 10.9265Z"
        fill="#FF822D"
      />
      <path
        d="M2.72372 20.0529C2.47673 19.9294 2.17639 20.0295 2.0529 20.2765C1.9294 20.5235 2.02951 20.8238 2.2765 20.9473L6.2765 22.9473C6.52349 23.0708 6.82383 22.9707 6.94732 22.7237C7.07082 22.4767 6.97071 22.1764 6.72372 22.0529L2.72372 20.0529Z"
        fill="#FF6723"
      />
      <path
        d="M2.72372 26.9473C2.47673 27.0708 2.17639 26.9707 2.0529 26.7237C1.9294 26.4767 2.02951 26.1764 2.2765 26.0529L6.2765 24.0529C6.52349 23.9294 6.82383 24.0295 6.94732 24.2765C7.07082 24.5235 6.97071 24.8238 6.72372 24.9473L2.72372 26.9473Z"
        fill="#FF6723"
      />
      <path
        d="M29.9473 20.2765C29.8238 20.0295 29.5235 19.9294 29.2765 20.0529L25.2765 22.0529C25.0295 22.1764 24.9294 22.4767 25.0529 22.7237C25.1764 22.9707 25.4767 23.0708 25.7237 22.9473L29.7237 20.9473C29.9707 20.8238 30.0708 20.5235 29.9473 20.2765Z"
        fill="#FF6723"
      />
      <path
        d="M29.2765 26.9473C29.5235 27.0708 29.8238 26.9707 29.9473 26.7237C30.0708 26.4767 29.9707 26.1764 29.7237 26.0529L25.7237 24.0529C25.4767 23.9294 25.1764 24.0295 25.0529 24.2765C24.9294 24.5235 25.0295 24.8238 25.2765 24.9473L29.2765 26.9473Z"
        fill="#FF6723"
      />
      <path
        d="M9.9472 15.2765C9.82371 15.0295 9.52337 14.9294 9.27638 15.0529C9.02939 15.1764 8.92928 15.4767 9.05277 15.7237C9.24843 16.115 9.64118 16.6722 10.208 17.1368C10.2524 17.1732 10.2981 17.2092 10.3449 17.2445C10.1336 17.4279 9.99999 17.6984 9.99999 18.0001V19.0001C9.99999 19.5524 10.4477 20.0001 11 20.0001C11.5523 20.0001 12 19.5524 12 19.0001V18.0001C12 17.9875 11.9998 17.975 11.9993 17.9626C12.1604 17.9869 12.3273 18.0001 12.5 18.0001C12.7761 18.0001 13 17.7763 13 17.5001C13 17.224 12.7761 17.0001 12.5 17.0001C11.8459 17.0001 11.2876 16.7287 10.842 16.3634C10.3921 15.9947 10.0849 15.5518 9.9472 15.2765Z"
        fill="#402A32"
      />
      <path
        d="M20 18.0001C20 17.9875 20.0002 17.975 20.0007 17.9626C19.8396 17.9869 19.6726 18.0001 19.5 18.0001C19.2238 18.0001 19 17.7763 19 17.5001C19 17.224 19.2238 17.0001 19.5 17.0001C20.154 17.0001 20.7124 16.7287 21.158 16.3634C21.6078 15.9947 21.9151 15.5518 22.0528 15.2765C22.1763 15.0295 22.4766 14.9294 22.7236 15.0529C22.9706 15.1764 23.0707 15.4767 22.9472 15.7237C22.7515 16.115 22.3588 16.6722 21.792 17.1368C21.7475 17.1732 21.7019 17.2092 21.6551 17.2445C21.8664 17.4279 22 17.6984 22 18.0001V19.0001C22 19.5524 21.5523 20.0001 21 20.0001C20.4477 20.0001 20 19.5524 20 19.0001V18.0001Z"
        fill="#402A32"
      />
      <path
        d="M16 24.5001C14.6098 24.5001 13.6831 25.3769 13.416 25.7775C13.2628 26.0072 12.9524 26.0693 12.7226 25.9161C12.4929 25.763 12.4308 25.4525 12.584 25.2228C12.9455 24.6804 13.9679 23.7091 15.5 23.5292V21.0001C15.5 20.724 15.7238 20.5001 16 20.5001C16.2761 20.5001 16.5 20.724 16.5 21.0001V23.5292C18.0321 23.7091 19.0544 24.6804 19.416 25.2228C19.5692 25.4525 19.5071 25.763 19.2773 25.9161C19.0476 26.0693 18.7371 26.0072 18.584 25.7775C18.3169 25.3769 17.3902 24.5001 16 24.5001Z"
        fill="#402A32"
      />
      <path
        d="M17.0429 20H14.9571C14.5117 20 14.2886 20.5386 14.6036 20.8536L15.6465 21.8964C15.8417 22.0917 16.1583 22.0917 16.3536 21.8964L17.3965 20.8536C17.7114 20.5386 17.4884 20 17.0429 20Z"
        fill="#F70A8D"
      />
    </svg>
  );
};
